// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  padding-right: 11px;
  padding-left: 32px;
}

.list-item-color {
  color: #666565;
  white-space: normal;
}

.div-item {
  display: flex;
  width: 100%;
}

ion-fab-button {
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --color: black;
  --box-shadow: none !important;
  margin-left: 15%;
  pointer-events: none;
}

.iconStyle {
  transform: rotate(90deg);
  font-size: 20px;
  opacity: 0.6;
  margin-left: 5px;
}

.horizontal-line {
  border-left: 2px dotted rgba(173, 167, 167, 0.7803921569);
  height: 68px;
  margin-right: 3px;
}

.horizontal {
  margin-top: -33px;
}

.fltSwipeCircle {
  position: sticky;
  align-self: flex-start; /* stick at top */
  margin-left: auto; /* push to right */
  margin-top: -22px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 8px;
  box-shadow: 0 1px 30px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  color: #727272;
  z-index: 1000;
}

.ios .horizontal-line {
  margin-right: 6px;
  height: 83px;
}

.ios .horizontal {
  margin-top: -43px;
}

.font-Size {
  font-size: smaller;
}`, "",{"version":3,"sources":["webpack://./src/app/trips/schedule-creation/schedule-airport/schedule-airport.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,WAAA;AAEF;;AACA;EACE,yBAAA;EACA,mCAAA;EACA,+BAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;AAEF;;AAAA;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAGF;;AADA;EACE,yDAAA;EACA,YAAA;EACA,iBAAA;AAIF;;AAFA;EACE,iBAAA;AAKF;;AAHA;EACG,gBAAA;EAED,sBAAA,EAAA,iBAAA;EACA,iBAAA,EAAA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,2CAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AAKF;;AAoBA;EACE,iBAAA;EACA,YAAA;AAjBF;;AAmBA;EACE,iBAAA;AAhBF;;AAkBA;EACE,kBAAA;AAfF","sourcesContent":[".icon {\n  padding-right: 11px;\n  padding-left: 32px;\n}\n\n.list-item-color {\n  color: #666565;\n  white-space: normal;\n}\n.div-item {\n  display: flex;\n  width: 100%;\n}\n\nion-fab-button {\n  --background: transparent;\n  --background-activated: transparent;\n  --background-hover: transparent;\n  --color: black;\n  --box-shadow: none !important; \n  margin-left: 15%;\n  pointer-events: none;\n}\n.iconStyle{\n  transform: rotate(90deg);\n  font-size: 20px;\n  opacity: 0.6;\n  margin-left: 5px;\n}\n.horizontal-line {\n  border-left: 2px dotted  #ada7a7c7;\n  height: 68px;\n  margin-right: 3px;\n}\n.horizontal {\n  margin-top: -33px;\n}\n.fltSwipeCircle {\n   position: sticky;\n  // top: 10px; /* vertical stick */\n  align-self: flex-start; /* stick at top */\n  margin-left: auto; /* push to right */\n  margin-top: -22px;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 8px;\n  box-shadow: 0 1px 30px 0 rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  color: #727272;\n  z-index: 1000;\n  // position: sticky; /* or absolute, depending on your layout */\n  // top: 10px;        /* vertically center - adjust as needed */\n  // right: 10px;     /* distance from the right edge */\n  // transform: translateY(-50%);\n  // width: 40px;\n  // height: 40px;\n  // flex-shrink: 0;\n  // border-radius: 100%;\n  // background: #fff;\n  // display: flex;\n  // align-items: center;\n  // justify-content: center;\n  // box-shadow: 0 1px 30px 0 rgba(0, 0, 0, 0.1);\n  // z-index: 1000;  /* higher to appear on top */\n  // cursor: pointer;\n  // color: rgb(0, 140, 255);\n  // margin-left: 0; /* remove left margin */\n}\n// .horizontal{\n//   margin-top: -10px;\n//   right: 22px;\n//   font-size: 18px;\n// }\n\n.ios .horizontal-line{\n  margin-right: 6px;\n  height: 83px;\n}\n.ios .horizontal{\n  margin-top: -43px;\n}\n.font-Size {\n  font-size:smaller;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
